enum Flags {
  SpendingBucketsDefaultTab = 'FF_spending-buckets-default-tab',
  StkDefaultTab = 'FF_stk-default-tab',
  SBVersion = 'FF_spending-buckets-api-version',
  CapiTransfersApigeeMigration = 'FF_capi-transfers-apigee',
  SBManageAlerts = 'FF_spending-buckets-manage-alerts',
  TransactionSearchApigee = 'FF_transaction-search-apigee',
  TransactionDownloadApigee = 'FF_transaction-history-download-apigee',
  StkIncreaseBucketLimit = 'FF_stk-increase-bucket-limit',
  RemoveAutoDistribution = 'FF_spending-buckets-remove-distribution',
  SbDueDateOptional = 'FF_spending-buckets-due-date-optional',
  RegDContentUpdate = 'FF_reg-d-2023',
  UnbucketedTransactions = 'FF_allow-transactions-move-to-unbucketed',
  SpendingVisualizations = 'FF_spending-account-visualization-test',
}

const defaultValues = {
  [Flags.SpendingBucketsDefaultTab]: 'activity',
  [Flags.StkDefaultTab]: 'activity',
  [Flags.SBVersion]: 'v4',
  [Flags.CapiTransfersApigeeMigration]: false,
  [Flags.SBManageAlerts]: false,
  [Flags.TransactionSearchApigee]: false,
  [Flags.TransactionDownloadApigee]: false,
  [Flags.StkIncreaseBucketLimit]: false,
  [Flags.RemoveAutoDistribution]: false,
  [Flags.SbDueDateOptional]: false,
  [Flags.RegDContentUpdate]: false,
  [Flags.UnbucketedTransactions]: false,
  [Flags.SpendingVisualizations]: false,
}

export { Flags, defaultValues }
